import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss']
})
export class ReadMoreComponent implements OnInit {

  @Input('content') content ! : string;
  @Input('limit') limit ! : number;
  @Input('completeWords') completeWords !: boolean;

  isContentToggled !: boolean;
  nonEditedContent !: string;
  constructor() { }

  ngOnInit(): void {

    console.log(this.content);
    this.nonEditedContent = this.content;
    this.content = this.formatContent(this.content);
  }


  toggleContent() {
    this.isContentToggled = !this.isContentToggled;
    this.content = this.isContentToggled ? this.nonEditedContent : this.formatContent(this.content);
  }

  formatContent(content: string) {
    if (this.completeWords) {
      this.limit = content.substring(0, this.limit).lastIndexOf(' ');
    }
    return `${content.substring(0, this.limit)}...`;
  }
}
